import React from "react";

const FloorPlans = ({ data, onEnquire }) => {
  return (
    <section id="floor-plans" className="py-12 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        {/* Main Heading */}
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-bold text-[#090C6A]">
            Floor Plans
          </h2>
          <div className="w-24 h-1 bg-[#090C6A] mx-auto mt-3 rounded"></div>
        </div>

        {/* Plans Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          {/* Master Plan */}
          <div className="text-center">
            <h3 className="text-xl md:text-2xl font-semibold text-[#090C6A] mb-4">
              Master Plan Layout
            </h3>
            <div className="w-20 h-[2px] bg-[#090C6A] mx-auto mb-6"></div>

            <div className="group relative overflow-hidden rounded-xl shadow-lg cursor-pointer">
              <img
                src={data.floorPlan[0]}
                alt="Rainbow Life Master Plan"
                className="w-full h-[260px] md:h-[300px] object-cover transition-transform duration-700 group-hover:scale-110"
              />

              <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition duration-500"></div>

              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 scale-75 group-hover:scale-100 transition-all duration-500">
                <button
                  className="bg-[#090C6A] hover:bg-[#1218A6] text-white px-6 py-3 rounded-full font-medium shadow-lg"
                  onClick={onEnquire}
                >
                  Request Master Layout Plan
                </button>
              </div>
            </div>
          </div>

          {/* Unit Plan */}
          <div className="text-center">
            <h3 className="text-xl md:text-2xl font-semibold text-[#090C6A] mb-4">
              Unit Plan
            </h3>
            <div className="w-20 h-[2px] bg-[#090C6A] mx-auto mb-6"></div>

            <div className="group relative overflow-hidden rounded-xl shadow-lg cursor-pointer">
              <img
                src={data.floorPlan[1]}
                alt="Rainbow Life Unit Plan"
                className="w-full h-[260px] md:h-[300px] object-cover transition-transform duration-700 group-hover:scale-110"
              />

              <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition duration-500"></div>

              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 scale-75 group-hover:scale-100 transition-all duration-500">
                <button
                  className="bg-[#090C6A] hover:bg-[#1218A6] text-white px-6 py-3 rounded-full font-medium shadow-lg"
                  onClick={onEnquire}
                >
                  Request Unit Plan Layout
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FloorPlans;
